import AppliedFilterSection from './AppliedFilterSection'

export default AppliedFilterSection
